import type { BoundingBoxItem } from "./bounding-box.type";
import type { CSSProperties } from "react";

export const getBoundingBoxStyle = (box: BoundingBoxItem): CSSProperties => {
  return {
    left: `${box.left * 100}%`,
    top: `${box.top * 100}%`,
    width: `${box.width * 100}%`,
    height: `${box.height * 100}%`,
  };
};
